module.exports = __webpack_public_path__ + "static/media/folder.061d3ead.svg";